import {Button, TextField} from "@mui/material";
import {useRef} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {CheckCircle} from "@mui/icons-material";
import useAlert from "../../../../../../../use/useAlert";
import Box from "@mui/material/Box";
import NotifyIdentifyIssue from "./NotifyIdentifyIssue";

export default function ({next}) {
    const alert = useAlert();
    const identifyIssue = useRef();

    const nextStep = () => {
        const value = identifyIssue.current.value;

        if (value.trim().length === 0) {
            alert.warning("Veuillez compléter le compte rendu");
            return;
        }

        next({
            identified_issue: identifyIssue.current.value
        });
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyIdentifyIssue/>
                </Box>
                <Box mt={5} px={2}>
                    <TextField
                        label={"Problème identifié"}
                        fullWidth={true}
                        multiline={true}
                        minRows={10}
                        maxRows={20}
                        inputRef={identifyIssue}
                        data-test="input-identified-issue"
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}